import _ from 'lodash';
import { makeUID } from '../../../../helpers';

const extractDataFromResponse = (resp) => (resp && !resp.error ? resp : []);
const extractUserRoles = (userRoles) => (userRoles && !userRoles.error ? ({
  curator: userRoles.curator,
  employer: userRoles.employer,
  head: userRoles.head,
  admin: userRoles.admin,
  participantAdmin: userRoles.participantAdmin,
  mainConstructor: userRoles.mainConstructor,
  officeTechLead: userRoles.officeTechLead,
}) : {});

export const getMngData = async (api) => {
  const letters = await api.get('/mng/letters');
  const finSources = await api.get('/mng/finsources');
  const kpis = await api.get('/mng/kpis');
  const userRoles = await api.get('/mng/proj/userRoles');
  const projTypes = await api.get('/mng/proj/types');
  const resultTypes = await api.get('/mng/proj/resulttypes');

  return {
    letters: extractDataFromResponse(letters),
    finSources: extractDataFromResponse(finSources),
    kpis: extractDataFromResponse(kpis).filter((kpi) => kpi.num && kpi.num[0] !== 'П'), // P2030-132 убрать все "П*" показатели
    userRoles: extractUserRoles(userRoles),
    projTypes: extractDataFromResponse(projTypes),
    resultTypes: extractDataFromResponse(resultTypes),
  };
};

export const getPeriodsData = async (api) => {
  const response = await api.get('/reports/periods/passport');
  return !response.error ? response : [];
};

export const _default = {
  mngData: {
    letters: [],
    finSources: [],
    kpis: [],
    userRoles: [],
    projTypes: [],
    resultTypes: [],
  },
  portfolio: (stratId, projId) => ({
    id: projId !== 'new' ? projId : 0,
    number: undefined,
    fullNumber: '',
    name: '',
    version: 1,
    approvedOn: '',

    strategyId: stratId || 0,
    strategyName: '',

    startDate: new Date().toISOString().substring(0, 10),
    endDate: new Date().toISOString().substring(0, 10),

    goal: '',
    descr: '',

    result: '',
    consumers: '',

    kpis: [],
    letters: [],
    results: [{
      id: 0, title: '', year: undefined, projResultTypeId: undefined, unit: '', value: '',
    }],
    pcs: [],
    plans: [{
      id: 0, type: 'fb', year: undefined, agreementId: undefined, bcCodeId: undefined, fundingId: undefined, sum: undefined,
    }],
    users: [],
    approvers: [],
  }),
};
